<div class="row">
  <div class="p-1" [ngClass]="isCollapsed ? 'col-3' : 'col-12'">
    <div class="card mb-2">
      <div class="card-header">
        <span class="client-header-content"
          >Clients
          <mdb-badge [ngClass]="getStateBadge()" *ngIf="this.filterableClients.length > 0">{{
            this.buildClientCountString()
          }}</mdb-badge></span
        >
        <div (click)="onGridCollapse()">
          <ng-container *ngIf="!isCollapsed">
            <span class="fas fa-angle-double-left"></span>
          </ng-container>
          <ng-container *ngIf="isCollapsed">
            <span class="fas fa-angle-double-right"></span>
          </ng-container>
        </div>
      </div>

      <div class="card-body my-auto" *ngIf="loadingClientList">
        <app-loading [busy]="loadingClientList" [busyText]="'Loading clients...'"></app-loading>
      </div>

      <div class="card-body my-auto d-sm-flex" *ngIf="!loadingClientList">
        <div class="table-responsive">
          <table class="table" mdbTable hover="true" small="true">
            <thead *ngIf="!isCollapsed">
              <tr>
                <th>
                  <div class="md-form">
                    <input
                      [(ngModel)]="searchText"
                      mdbInput
                      name="searchText"
                      type="search"
                      id="searchText"
                      placeholder="Search"
                      style="font-size: small; border-bottom-color: #7b7f82"
                    />
                  </div>
                </th>
                <th>
                  <div class="md-form">
                    <select
                      class="md-form form-control browser-default"
                      style="font-size: small"
                      id="step"
                      [(ngModel)]="selectedStepId"
                      placeholder="Steps"
                      (change)="filterByStepId()"
                    >
                      <option [ngValue]="null">-- Select Step --</option>
                      <ng-container *ngFor="let step of clientListResponse.steps">
                        <option [ngValue]="step.id">
                          {{ step.categoryAndStepDescription }}
                        </option>
                      </ng-container>
                    </select>
                    <label for="stepFilter" class="active">Filter Steps</label>
                  </div>
                </th>
                <th>
                  <div class="md-form">
                    <select
                      class="md-form form-control browser-default"
                      style="font-size: small"
                      id="clientState"
                      [(ngModel)]="selectedClientState"
                      placeholder="State"
                      (change)="onStateFilterChange()"
                    >
                      <option *ngFor="let option of clientStateOptions" [ngValue]="option.value">
                        {{ option.label }}
                      </option>
                    </select>
                    <label for="clientState" class="active">Filter Client State</label>
                  </div>
                </th>
              </tr>
              <tr class="table-header">
                <th class="sortable" [appSort]="filterableClients" data-name="fullName">Client</th>
                <ng-container *ngIf="!isCollapsed">
                  <th class="sortable" [appSort]="filterableClients" data-order="desc" data-name="nextStepDescription">Next Step</th>
                  <th style="min-width: 130px">Last Completed Step</th>

                  <th>Last Note</th>
                  <th
                    class="sortable"
                    style="min-width: 125px"
                    [appSort]="filterableClients"
                    data-order="desc"
                    data-name="lastUpdatedDateTime"
                    data-type="date"
                  >
                    Last Updated
                  </th>
                </ng-container>
              </tr>
            </thead>

            <thead *ngIf="isCollapsed">
              <tr>
                <th>
                  <div class="md-form">
                    <input
                      [(ngModel)]="searchText"
                      mdbInput
                      name="searchText"
                      type="search"
                      id="searchText"
                      placeholder="Search"
                      style="font-size: small; border-bottom-color: #7b7f82"
                    />
                  </div>
                </th>
              </tr>
              <tr class="table-header">
                <th class="sortable" [appSort]="filterableClients" data-name="fullName">Client</th>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngFor="let clientInfo of filterableClients | filter: searchText">
                <tr (click)="onClientSelect(clientInfo.userId)" [ngClass]="{ 'selected-client': clientInfo.userId === selectedClientId }">
                  <td class="d-sm-flex" style="justify-content: space-between">
                    {{ clientInfo.fullName }}
                    <!-- KEEPING THIS AROUND FOR FUTURE IMPLEMENTATION OF TAGS AND FLAGS
                     <span>
                      <span class="fas fa-flag" style="color: red"></span>
                      <span class="fas fa-crown" style="color: green"></span>
                      <span class="fas fa-triangle-exclamation" style="color: red"></span>
                      <span class="fas fa-triangle-exclamation" style="color: orange"></span>
                      <span class="fas fa-circle-pause" style="color: grey"></span>
                    </span> -->
                  </td>
                  <ng-container *ngIf="!isCollapsed">
                    <td>
                      <strong>{{ clientInfo.nextStepDescription }}</strong>
                    </td>
                    <td class="text-muted small">
                      {{ clientInfo.lastCompletedStepDescription }}
                    </td>
                    <td>
                      {{ clientInfo.lastNote }}
                    </td>
                    <td>{{ clientInfo.lastUpdatedDateTime | date: "dd MMM yyyy" }}</td>
                  </ng-container>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="col-9">
    <div class="row">
      <div class="col-12">
        <ng-container *ngIf="isCollapsed && selectedClientId == null">
          <div class="col-12 p-1">
            <div class="card">
              <div class="card-header my-auto">Please select a client to continue onboarding them</div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="infoLoading">
          <div class="card-body my-auto">
            <app-loading [busy]="infoLoading" [busyText]="'Loading client...'"></app-loading>
          </div>
        </ng-container>
        <ng-container *ngIf="!infoLoading">
          <ng-container *ngIf="selectedClientId != null">
            <div class="row">
              <div class="col-12 p-1">
                <div class="card">
                  <div class="card-header my-auto d-sm-flex" style="justify-content: space-between">
                    <div>
                      <strong>{{ onboardingClient.fullName }}</strong> ({{ onboardingClient.userId }})
                      <mdb-badge *ngIf="!onboardingClient?.isActive" color="black">Archived</mdb-badge>
                      <div class="text-muted small">
                        Created: {{ onboardingClient.clientCreatedDate | date: "dd MMM yyyy" }} -
                        {{ onboardingClient.clientCreatedDate | daysAgo }}
                      </div>
                    </div>
                    <div class="d-sm-flex" style="justify-content: space-between">
                      <app-loading [busy]="loadingProfile"></app-loading>
                      <ng-container *ngIf="onboardingClient?.isActive && !loadingClientList">
                        <button mdbBtn color="trakly1" class="relative waves-light btn-sm btn" (click)="archiveClient()">Archive</button>
                      </ng-container>

                      <ng-container *ngIf="!loadingProfile">
                        <button mdbBtn color="trakly-action" class="relative waves-light btn-sm btn" (click)="onEditProfileClick()">
                          Edit Profile
                        </button>
                      </ng-container>

                      <ng-container *ngIf="canComplete()">
                        <button mdbBtn color="trakly1" class="relative waves-light btn-sm btn" (click)="completeOnboardingProcess()">
                          Complete Onboarding
                        </button>
                      </ng-container>

                      <ng-container *ngIf="canRestart()">
                        <button mdbBtn color="trakly" class="relative waves-light btn-sm btn" (click)="restartOnboardingProcess()">
                          Restart Onboarding
                        </button>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="row">
                  <ng-container *ngIf="onboardingClient.isActive">
                    <app-categories-steps
                      *ngIf="!canRestart()"
                      [onboardingClient]="onboardingClient"
                      (stepNoteAdded)="handleNoteCreated($event)"
                      class="col-5 p-1"
                    >
                    </app-categories-steps>
                  </ng-container>
                  <div class="col-7 p-1">
                    <div class="card">
                      <div class="card-header">Notes</div>

                      <div class="card-body">
                        <ng-container>
                          <app-create-note
                            [clientId]="selectedClientId"
                            [createdByUserId]="createdByUserId"
                            (noteCreateError)="parseAndDisplayError($event)"
                            (noteCreated)="handleNoteCreated($event)"
                          ></app-create-note>
                        </ng-container>

                        <app-notes [newNote]="newNote" [clientId]="selectedClientId" [createdByUserId]="createdByUserId"></app-notes>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <app-user-profile-modal
    [selectedUserDetails]="selectedUserFullDetails"
    [(showModal)]="showUserProfileModal"
    (onModelChange)="handleUserProfileUpdated($event)"
  ></app-user-profile-modal>
</div>
<error-component [error]="errorResponse" [(showModal)]="showError"></error-component>
